// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_gi-0";
export var headerCellHover = "_gi-1";
export var readCellContainer = "_gi-2";
export var unreadIndicator = "_gi-3";